var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-circulating-water" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-title" }, [_vm._v(_vm._s(_vm.name))]),
      _c("div", { staticClass: "header-logo" }, [
        _c("img", {
          attrs: { src: _vm.ossHost + "img/big_screen_logo.png", alt: "" }
        })
      ])
    ]),
    _c("div", { staticClass: "page-body" }, [
      _c("div", { staticClass: "body-top" }, [
        _c("div", { staticClass: "top-crm-left top-crm" }, [
          _c("div", { staticClass: "crm-title" }, [_vm._v("水质管理系统")]),
          _c(
            "div",
            { staticClass: "crm-list" },
            _vm._l(_vm.bucketList, function(item) {
              return _c(
                "div",
                {
                  key: item.encodeId,
                  class: {
                    "list-item": true,
                    "error-item": item.oxygen && item.oxygen < item.minOxygen
                  }
                },
                [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  _c(
                    "div",
                    {
                      class: {
                        "item-number-list": true,
                        "warning-text":
                          item.oxygen && item.oxygen < item.minOxygen
                      }
                    },
                    [
                      _c("span", [_vm._v("溶氧")]),
                      _c("span", [_vm._v(_vm._s(item.oxygen || "-"))])
                    ]
                  ),
                  _c("div", { class: { "item-number-list": true } }, [
                    _c("span", [_vm._v("水温")]),
                    _c("span", [_vm._v(_vm._s(item.temperature || "-"))])
                  ]),
                  _c("div", { class: { "item-number-list": true } }, [
                    _c("span", [_vm._v("水压")]),
                    _c("span", [_vm._v(_vm._s(item.airPressure || "-"))])
                  ])
                ]
              )
            }),
            0
          )
        ]),
        _c("div", { staticClass: "top-crm-center top-crm" }, [
          _c("div", { staticClass: "crm-title" }, [_vm._v("视频监控系统")]),
          _c(
            "div",
            { class: { "slider-box": true, loading: _vm.loading } },
            [
              _c(
                "el-carousel",
                { attrs: { interval: 40000, type: "always" } },
                _vm._l(_vm.videoList, function(item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "slider-item",
                        staticStyle: { "min-height": "0.9rem" }
                      },
                      [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _c("div", {
                          staticClass: "prism-player",
                          staticStyle: { "min-height": "0.85rem" },
                          attrs: { id: "video-" + index }
                        })
                      ]
                    )
                  ])
                }),
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "top-crm-right top-crm" }, [
          _c("div", { staticClass: "crm-title" }, [_vm._v("投喂管理系统")]),
          _c("div", { staticClass: "crm-count-box" }, [
            _c("img", {
              attrs: { src: _vm.ossHost + "img/icon_base_tl.png", alt: "" }
            }),
            _c("div", { staticClass: "power-count" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.feedingSystemView.monthFood))]),
                _vm._v(" 斤 ")
              ]),
              _c("div", { staticClass: "desc" }, [
                _vm._v("同比上月 "),
                _c("span", {
                  class: { iconfont: true, "icon-rise-filling": true }
                }),
                _vm._v(
                  " " + _vm._s(_vm.feedingSystemView.mtmGrowth * 100) + "% "
                )
              ])
            ]),
            _c("div", { staticClass: "right" }, [_vm._v("本月投料量")])
          ]),
          _c("div", { staticClass: "crm-tl-chart-box" }, [
            _c("div", {
              style: { width: "100%", minHeight: "0.6rem" },
              attrs: { id: "tl-chart" }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "body-bottom" }, [
        _c("div", { staticClass: "bottom-left bottom-child" }, [
          _c("div", { staticClass: "crm-title" }, [_vm._v("生化系统")]),
          _c("div", { staticClass: "crt-bottom-box" }, [
            _c(
              "div",
              {
                class: {
                  "list-item": true,
                  "error-item":
                    _vm.biochemicalSystem.oxygen &&
                    _vm.biochemicalSystem.oxygen <
                      _vm.biochemicalSystem.minOxygen
                }
              },
              [
                _c("div", { staticClass: "item-title" }, [_vm._v("实时数据")]),
                _c(
                  "div",
                  {
                    class: {
                      "item-number-list": true,
                      "warning-text":
                        _vm.biochemicalSystem.oxygen &&
                        _vm.biochemicalSystem.oxygen <
                          _vm.biochemicalSystem.minOxygen
                    }
                  },
                  [
                    _c("span", [_vm._v("溶氧")]),
                    _c("span", [_vm._v(_vm._s(_vm.biochemicalSystem.oxygen))])
                  ]
                ),
                _c("div", { class: { "item-number-list": true } }, [
                  _c("span", [_vm._v("pH")]),
                  _c("span", [_vm._v(_vm._s(_vm.biochemicalSystem.ph))])
                ]),
                _c("div", { class: { "item-number-list": true } }, [
                  _c("span", [_vm._v("氨氮")]),
                  _c("span", [_vm._v(_vm._s(_vm.biochemicalSystem.nhn))])
                ]),
                _c("div", { class: { "item-number-list": true } }, [
                  _c("span", [_vm._v("亚硝酸盐")]),
                  _c("span", [_vm._v(_vm._s(_vm.biochemicalSystem.nit))])
                ])
              ]
            ),
            _c("div", { staticClass: "chart-box" }, [
              _c("div", {
                style: { width: "100%", minHeight: "0.55rem" },
                attrs: { id: "ph-chart" }
              })
            ]),
            _c("div", { staticClass: "chart-box" }, [
              _c("div", {
                style: { width: "100%", minHeight: "0.55rem" },
                attrs: { id: "nh-chart" }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "bottom-right bottom-child" }, [
          _c("div", { staticClass: "crm-title kzq-title" }, [
            _vm._v("动力系统")
          ]),
          _c("div", { staticClass: "chart" }, [
            _c("div", { staticClass: "kzq-left" }, [
              _c("div", { staticClass: "kzq-power-box" }, [
                _c("img", {
                  attrs: {
                    src: "https://static.yudada.com/admin/img/plug.png",
                    alt: ""
                  }
                }),
                _c("div", { staticClass: "power-count" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.kzqData.currentMonthQuantity))
                    ]),
                    _vm._v(" 度 ")
                  ]),
                  _vm.kzqData.upPower
                    ? _c("div", { staticClass: "desc" }, [
                        _vm._v("同比上月 "),
                        _c("span", {
                          class: {
                            iconfont: true,
                            "icon-rise-filling": _vm.kzqData.upPower >= 0,
                            "icon-decline-filling": _vm.kzqData.upPower < 0
                          }
                        }),
                        _vm._v(
                          " " + _vm._s(Math.abs(_vm.kzqData.upPower)) + "% "
                        )
                      ])
                    : _vm._e()
                ]),
                _c("div", { staticClass: "right" }, [_vm._v("本月用电量")])
              ]),
              _vm.kzqData.electricConsumption
                ? _c("div", { staticClass: "power-count-item-box" }, [
                    _c("div", { staticClass: "power-count-item" }, [
                      _c("div", { staticClass: "label-text" }, [
                        _vm._v(
                          _vm._s(_vm.kzqData.customerSwitchName[0] || "第一路")
                        )
                      ]),
                      _c("div", {
                        class: {
                          "power-chart": true,
                          "max-item": _vm.kzqData.maxIndex == 0,
                          "empty-item": !_vm.kzqData.electricConsumption[0]
                        },
                        style: { width: _vm.kzqData.powerWidth[0] + "rem" }
                      }),
                      _c("div", { staticClass: "count" }, [
                        _vm._v(_vm._s(_vm.kzqData.electricConsumption[0]))
                      ])
                    ]),
                    _c("div", { staticClass: "power-count-item" }, [
                      _c("div", { staticClass: "label-text" }, [
                        _vm._v(
                          _vm._s(_vm.kzqData.customerSwitchName[1] || "第二路")
                        )
                      ]),
                      _c("div", {
                        class: {
                          "power-chart": true,
                          "max-item": _vm.kzqData.maxIndex == 1,
                          "empty-item": !_vm.kzqData.electricConsumption[1]
                        },
                        style: { width: _vm.kzqData.powerWidth[1] + "rem" }
                      }),
                      _c("div", { staticClass: "count" }, [
                        _vm._v(_vm._s(_vm.kzqData.electricConsumption[1]))
                      ])
                    ]),
                    _c("div", { staticClass: "power-count-item" }, [
                      _c("div", { staticClass: "label-text" }, [
                        _vm._v(
                          _vm._s(_vm.kzqData.customerSwitchName[2] || "第三路")
                        )
                      ]),
                      _c("div", {
                        class: {
                          "power-chart": true,
                          "max-item": _vm.kzqData.maxIndex == 2,
                          "empty-item": !_vm.kzqData.electricConsumption[2]
                        },
                        style: { width: _vm.kzqData.powerWidth[2] + "rem" }
                      }),
                      _c("div", { staticClass: "count" }, [
                        _vm._v(_vm._s(_vm.kzqData.electricConsumption[2]))
                      ])
                    ]),
                    _c("div", { staticClass: "power-count-item" }, [
                      _c("div", { staticClass: "label-text" }, [
                        _vm._v(
                          _vm._s(_vm.kzqData.customerSwitchName[3] || "第四路")
                        )
                      ]),
                      _c("div", {
                        class: {
                          "power-chart": true,
                          "max-item": _vm.kzqData.maxIndex == 3,
                          "empty-item": !_vm.kzqData.electricConsumption[3]
                        },
                        style: { width: _vm.kzqData.powerWidth[3] + "rem" }
                      }),
                      _c("div", { staticClass: "count" }, [
                        _vm._v(_vm._s(_vm.kzqData.electricConsumption[3]))
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "kzq-right" }, [
              _c(
                "div",
                { staticClass: "kzq-chart-title" },
                [
                  _c("div", { staticClass: "title-left" }, [
                    _vm._v("电流曲线")
                  ]),
                  _c(
                    "el-dropdown",
                    {
                      attrs: { "split-button": "", type: "primary" },
                      on: { command: _vm.handleCommand }
                    },
                    [
                      _vm.kzqData.switchNumber == 1
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[0] || "第一路"
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm.kzqData.switchNumber == 2
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[1] || "第二路"
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm.kzqData.switchNumber == 3
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[2] || "第三路"
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm.kzqData.switchNumber == 4
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[3] || "第四路"
                              )
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: "1" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[0] || "第一路"
                              ) + " "
                            )
                          ]),
                          _c("el-dropdown-item", { attrs: { command: "2" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[1] || "第二路"
                              ) + " "
                            )
                          ]),
                          _c("el-dropdown-item", { attrs: { command: "3" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[2] || "第三路"
                              ) + " "
                            )
                          ]),
                          _c("el-dropdown-item", { attrs: { command: "4" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.kzqData.customerSwitchName[3] || "第四路"
                              ) + " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "chart-parent" }, [
                _c("div", {
                  class: {
                    "is-show": _vm.kzqData.data && _vm.kzqData.data.length,
                    "kzq-chart-status": true
                  },
                  style: { width: "100%", minHeight: "0.5rem" },
                  attrs: { id: "kzq-chart" }
                }),
                !(_vm.kzqData.data && _vm.kzqData.data.length)
                  ? _c("div", { staticClass: "empty-box" }, [
                      _vm._v("暂无数据")
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "page-footer" }, [
      _c("div", { staticClass: "footer-text" }, [
        _vm._v("请使用微信扫码了解更多")
      ]),
      _c("img", {
        attrs: { src: _vm.ossHost + "img/weixin_qrcode.png", alt: "" }
      })
    ]),
    _vm.loading
      ? _c("div", { staticClass: "loading-page" }, [
          _c("div", { staticClass: "loading-box" }, [_vm._v("数据更新中...")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }